<template>
  <div class="search-panel" :class="{ 'showPopup': pilotNavOpen === 'search' }">
    <div class="search-header">
      <div class="lable">全文搜索</div>

      <svg class="icon-svg icon-close" @click="setPilotNav('')">
        <use xlink:href="#icon-close" />
      </svg>
    </div>

    <div class="search-content">
      <a-input-search
        class="search-input"
        ref="inputRef"
        v-model:value="keyword"
        placeholder="请输入关键词"
        @search="search()"
      />
      <div class="result-count">为您找到相关结果共{{ searchResults.length }}个</div>
    </div>
    <div class="results">
      <div class="list"
        v-for="item of formatedSearchResults"
        :key="item.inductionId"
      >
        <div class="induction">{{ item.inductionName }}</div>
        <div class="ret" 
          :class="{ 'active': activeRet === ret.id }"
          v-for="ret of item.children"
          :key="ret.id"
          :title="`来自章节《${item.inductionName}》`"
          v-html="ret.context"
          @click="jumpTargetNode(ret.inductionId, ret.id)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { uniq } from 'lodash'
import { mapMutations, mapState } from 'vuex'

const INTERACTION_NAME_MAP = {
  'discuss': '讨论',
  'exam': '选择题',
  'structuralReflection': '结构化反思',
  'vote': '投票',
  'waterfall': '图片瀑布流',
  'wordcloud': '词云',
  'sort': '排序',
  'match': '匹配',
  'blankFilling': '填空题',
  'trueFalse': '判断题',
}

function indexOfIgnoreCase(str, searchValue) {
  const lowerCaseStr = str.toLowerCase()
  const lowerCaseSearchValue = searchValue.toLowerCase()
  return lowerCaseStr.indexOf(lowerCaseSearchValue)
}

function lastIndexOfIgnoreCase(str, searchValue) {
  const lowerCaseStr = str.toLowerCase()
  const lowerCaseSearchValue = searchValue.toLowerCase()
  return lowerCaseStr.lastIndexOf(lowerCaseSearchValue)
}

export default {
  name: 'search-panel',
  props: {
    intList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      keyword: '',
      searchResults: [],
      formatedSearchResults: [],
      activeRet: '',
    }
  },
  computed: {
    ...mapState({
      pilotNavOpen: state => state.pilotNavOpen,
      searchKeyword: state => state.searchKeyword,
    }),
  },
  watch: {
    pilotNavOpen() {
      if(this.pilotNavOpen !== 'search') {
        this.removeHighlightBlcok()
        this.setSearchKeyword('')
      }
      else {
        setTimeout(() => {
          this.$refs.inputRef.focus()

          if(this.searchKeyword) {
            this.keyword = this.searchKeyword
            this.search()
          }
        }, 0)
      }
    },
  },
  methods: {
    ...mapMutations({
      setPilotNav: 'pilotNavOpen',
      setSearchKeyword: 'setSearchKeyword',
    }),

    extractContext(str) {
      const keyword = this.keyword.trim()
      const limit = 50

      const startIndex = indexOfIgnoreCase(str, keyword)
      if (startIndex === -1) return ''

      const lastIndex = lastIndexOfIgnoreCase(str, keyword)
      if (lastIndex === -1) return ''

      let start = startIndex - limit
      let end = lastIndex + keyword.length + limit
      let startEllipsis = '...'
      let endEllipsis = '...'

      if(startIndex - limit <= 0) {
        start = 0
        startEllipsis = ''
      }
      if(lastIndex + keyword.length + limit >= str.length) {
        end = str.length
        endEllipsis = ''
      }
      const context = startEllipsis + str.substring(start, end) + endEllipsis
      const regExp = new RegExp(keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
      return context.replace(regExp, '<span style="background-color: #fdc9cc;">$&</span>')
    },

    formatSearchResults() {
      let rets = uniq(this.searchResults)
      rets = rets.map(ret => {
        return {
          ...ret,
          context: this.extractContext(ret.context),
        }
      })
      function reorganize(arr) {
        return arr.reduce((result, item) => {
          const existingItem = result.find(r => r.inductionId === item.inductionId)
          if (existingItem) existingItem.children.push(item)
          else {
            result.push({
              inductionId: item.inductionId,
              inductionName: item.inductionName,
              children: [item],
            })
          }
          return result
        }, [])
      }
      this.formatedSearchResults = reorganize(rets)
    },

    search() {
      const keyword = this.keyword.trim()
      if(!keyword) return

      const searchResults = []
      const matchRegex = new RegExp(keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
      const textRegex = /(<([^>]+)>)/g

      for(const int of this.intList) {
        const textbookContent = int.TextbookContent
        if(!textbookContent) continue
        const { content } = JSON.parse(textbookContent)

        const div = document.createElement('div')
        div.innerHTML = content

        const selectors = [
          'h1[data-id]',
          'h2[data-id]',
          'h3[data-id]',
          'h4[data-id]',
          'h5[data-id]',
          'h6[data-id]',
          'p[data-id]',
          'pre[data-id]',
          'div.app-view[data-id]',
          'div.interaction-view[data-id]',
          'img[title]',
          'video[title]',
          'audio[title]'
        ]
        const blocks = div.querySelectorAll(selectors.join(','))
        
        for(const block of blocks) {
          if(['IMG', 'VIDEO', 'AUDIO'].includes(block.tagName)) {
            const text = block.title
            if(!text) continue

            if(text.indexOf(keyword) !== -1) {
              let id = block.dataset && block.dataset.id

              if(!id) {
                const parentNode = block.closest('[data-id]')
                if(!parentNode) continue
                id = parentNode.dataset.id
              }

              searchResults.push({
                inductionId: int.PK_InductionGuid,
                inductionName: int.InductionName,
                id,
                context: text,
              })
            }
          }
          else if(block.className === 'interaction-view') {
            const type = block.dataset.interactionType
            const text = '互动：' + INTERACTION_NAME_MAP[type]
            if(text.indexOf(keyword) !== -1) {
              searchResults.push({
                inductionId: int.PK_InductionGuid,
                inductionName: int.InductionName,
                id: block.dataset.id,
                context: text,
              })
            }
          }
          else if(block.className === 'app-view') {
            const text = `${block.dataset.appName}：${block.dataset.appTitle}`
            if(text.indexOf(keyword) !== -1) {
              searchResults.push({
                inductionId: int.PK_InductionGuid,
                inductionName: int.InductionName,
                id: block.dataset.id,
                context: text,
              })
            }
          }
          else {
            const html = block.innerText
            const text = html.replace(textRegex, '')
            const rets = text.match(matchRegex)
            if(rets) {
              searchResults.push(...new Array(rets.length).fill({
                inductionId: int.PK_InductionGuid,
                inductionName: int.InductionName,
                id: block.dataset.id,
                context: block.innerText,
              }))
            }
          }
        }
      }
      this.searchResults = searchResults
      this.formatSearchResults()
    },

    removeHighlightBlcok() {
      const highlightNodes = document.querySelectorAll('.search-highlight-block')
      for(const node of highlightNodes) {
        node.classList.remove('search-highlight-block')
      }
    },

    highlightBlcok(id) {
      this.removeHighlightBlcok()
      const block = document.querySelector(`[data-id='${id}']`)
      block.classList.add('search-highlight-block')
    },
    

    jumpTargetNode(inductionId, id) {
      this.activeRet = id
      this.$emit('jumpTargetNode', {
        inductionId,
        id,
      })
      setTimeout(() => {
        this.highlightBlcok(id)
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.search-highlight-block {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: -3px;
    background-color: rgba($color: yellow, $alpha: .25);
  }
}
</style>

<style lang="scss">
.search-panel {
  position: fixed;
  top: 60px;
  right: -400px;
  box-shadow: $box-shadow;
  border-radius: 14px;
  background-color: #ffffff;
  z-index: 99;
  height: calc(100% - 70px);
  width: 380px;
  transition: all .3s ease;
  font-size: 16px;
  display: flex;
  flex-direction: column;

  &.showPopup {
    right: 16px;
  }

  .search-header {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    color: #666;
    padding-bottom: 0;

    .lable {
      font-weight: 700;
      font-size: 18px;
      color: #333;
    }

    .icon-close {
      font-size: 22px;
      cursor: pointer;

      &:hover {
        color: #fdb8bc;
      }
    }
  }

  .search-content {
    padding: 8px 16px;

    .search-input {
      border-radius: 6px;
    }
  }

  .result-count {
    margin-top: 6px;
    font-size: 12px;
    color: #ccc;
  }

  .results {
    flex: 1;
    overflow: auto;
    padding: 8px 16px;

    .list {
      & + .list {
        margin-top: 20px;
      }
    }
    .induction {
      margin-bottom: 10px;
      font-size: 15px;
      font-weight: 700;
    }
    .ret {
      box-shadow: 0 0 10px #e5e5e5;
      padding: 15px;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        outline: 1px solid #fdb8bc;
      }
      &.active {
        outline: 2px solid #fdb8bc;
      }

      & + .ret {
        margin-top: 15px;
      }
    }
  }
}
</style>